import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// THUNK
export const getUsersList = createAsyncThunk(
    'users/getUsers',
    async ({ accountId, token, search = '', start = 0, length = 10 }, { rejectWithValue }) => {
    try {
        console.log('getUsersList - accountId:', accountId);
        console.log('getUsersList - token:', token ? 'presente' : 'non presente');
        console.log('getUsersList - pagination:', { search, start, length });
        
        // Costruisco URL con parametri di paginazione
        const params = new URLSearchParams({
            accountId,
            start: start.toString(),
            length: length.toString()
        });
        if (search) {
            params.append('search', search);
        }
        
        const url = `${import.meta.env.VITE_API_BASE_URL}/users/list?${params.toString()}`;
        const headers = {
            'Content-Type': 'application/json',
            'auth-token': token
        };
        const options = { method: 'GET', headers };
        
        console.log('getUsersList - URL:', url);
        
        const response = await fetch(url, options);
        console.log('getUsersList - response status:', response.status);
        
        if (!response.ok) {
            const error = await response.json();
            console.error('getUsersList - error:', error);
            return rejectWithValue({
                message: error.message || `Errore sconosciuto.`
            })
        }
        const result = await response.json();
        console.log('getUsersList - result:', result);
        return result
    } catch (error) {
        console.error('getUsersList - catch error:', error);
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
})

const initialState = {
    data: null,
    isLoading: false,
    error: null
};

const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        clearUsersData: (state) => {
            state.data = null;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUsersList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getUsersList.fulfilled, (state, action) => {
                state.data = action.payload;
                state.error = null
                state.isLoading = false;
            })
            .addCase(getUsersList.rejected, (state, action) => {
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento della lista utenti.";
                state.isLoading = false;
            })
    }
});

// Selector
export const selectUsersData = (state) => state.users.data;
export const selectUsersLoading = (state) => state.users.isLoading;
export const selectUsersError = (state) => state.users.error;

export const { clearUsersData } = usersSlice.actions;
export default usersSlice.reducer;
